import { Card, Col, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/PageHeader";
import { REPORT_CATALOG } from "./reportDefs";

export default function ReportsHubPage() {
  const navigate = useNavigate();
  const all = REPORT_CATALOG;
  const groups = Array.from(new Set(all.map((r) => r.group)));

  return (
    <div>
      <PageHeader title="Reports" />
      {groups.map((group) => (
        <div key={group} style={{ marginBottom: 24 }}>
          <Typography.Title level={5}>{group}</Typography.Title>
          <Row gutter={[16, 16]}>
            {all
              .filter((r) => r.group === group)
              .map((r) => (
                <Col xs={24} sm={12} lg={8} key={r.key}>
                  <Card hoverable title={r.title} onClick={() => navigate(`/reports/${r.key}`)} data-tour={`report-card-${r.key}`}>
                    {r.desc}
                  </Card>
                </Col>
              ))}
          </Row>
        </div>
      ))}
    </div>
  );
}
